import location from '@/api/product/location'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  locations: [],
  is_assign_storage: 'All',
  locationId: [],
  category_id: undefined,
  pro_group_id: undefined
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CATEGORY(state, data) {
    state.categories = data
  },
  SET_LOCATION(state, data) {
    state.locations = data
  },
  SET_IS_ASSIGN_STORAGE(state, data) {
    state.is_assign_storage = data
  },
  SET_CATEGORY_ID(state, categoryId) {
    state.category_id = categoryId
  },
  SET_GROUP_ID(state, groupId) {
    state.pro_group_id = groupId
  },
  SET_LOCATION_ID(state, locationIds) {
    state.locationId = locationIds
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          is_assign_storage: context.state.is_assign_storage,
          location_id: context.state.locationId,
          category_id: context.state.category_id,
          pro_group_id: context.state.pro_group_id
        }
      },
      attrubutes
    )
    return location.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return location.store(data)
  },
  destroy(context, id) {
    return location.destroy(id)
  },
  assignMultipleWarehouse(context, data) {
    return location.assignMultipleWarehouse(data)
  },
  async getLocation(context) {
    let response = await location.getLocation()
    context.commit('SET_LOCATION', response.data)
  },
  getProduct(context, attrubutes = {}) {
    let params = Object.assign({
      location_id: attrubutes.location_id
    })
    return location.getProduct({ params })
  },
  async getStorage(context, attrubutes = {}) {
    let params = Object.assign({
      filter: {
        location_id: attrubutes.location_id
      }
    })
    return location.getStorage({ params })
  },
  update(context, { id, data }) {
    return location.update(id, data)
  },
  getCategory(context) {
    return location.category()
  },
  getGroup(context, params) {
    return location.group(
      params !== undefined ? params.categoryId : context.state.category_id
    )
  },
  deleteMultiple(context, data) {
    return location.deleteMultiple(data)
  }
}
